import { getIn } from "formik";

const TimeInput = ({ label, name, formik, disabled, onChange }) => {
  const required = Object.keys(formik.initialValues).some((key) => key === name);
  const nestedError = getIn(formik.errors, name);
  const nestedTouched = getIn(formik.touched, name);

  return (
    <div className="relative w-full dark:text-white">
      {label && (
        <label className="block mb-1 font-semibold capitalize text-primary">
          {label} {required && <span className="text-mainRed">*</span>}
        </label>
      )}
      <div className="border-primary border  rounded-[12px] overflow-hidden flex items-center gap-1 px-2 bg-sideBar">
        <input
          type={"time"}
          name={name}
          onChange={onChange || (formik && formik.handleChange)}
          onBlur={formik && formik.handleBlur}
          value={formik.getFieldProps(name)?.value || ""}
          disabled={disabled}
          className="w-full px-2 py-2 bg-transparent h-14 focus-visible:outline-none"
          autoComplete="off"
        />

        {!disabled && nestedError && nestedTouched && (
          <span className="text-[12px] text-mainRed absolute bottom-[-18px]">
            {nestedError}
          </span>
        )}
      </div>
    </div>
  );
};

export default TimeInput;
